export enum SwitchTypeEnum {
    notification_sound = "notification_sound",
    warning_msg = "warning_msg",
    monitor_warning = "monitor_warning",
    data_filter = "data_filter" // 数据过滤开关
}

export interface Switch {
    id: number;
    projectId: number; // 项目ID
    switchName: string; //开关名称
    switchType: string; // 开关类型
    status: number // 0:已启用  1：未启用
    createTime: string;
}